import { CurrentEnvironment } from 'root-constants'

type TGrowthbookConfig = {
  apiHost: string
  clientKey: string
}

const GROWTHBOOK_API_HOST = 'https://cdn.growthbook.io'

const GROWTHBOOK_CONFIG_MAP: Record<
  CurrentEnvironment,
  TGrowthbookConfig
> = {
  [CurrentEnvironment.DEV]: {
    apiHost: GROWTHBOOK_API_HOST,
    clientKey: 'sdk-jbC23Ex4TanX3hv',
  },
  [CurrentEnvironment.DEV02]: {
    apiHost: GROWTHBOOK_API_HOST,
    clientKey: 'sdk-cg1rDX3PhY2HIg7',
  },
  [CurrentEnvironment.STAGE]: {
    apiHost: GROWTHBOOK_API_HOST,
    clientKey: 'sdk-nN46VbiI4FjILf',
  },
  [CurrentEnvironment.STAGE_QA]: {
    apiHost: GROWTHBOOK_API_HOST,
    clientKey: 'sdk-faQW6qXNzZR4KKhI',
  },
  [CurrentEnvironment.PROD]: {
    apiHost: GROWTHBOOK_API_HOST,
    clientKey: 'sdk-pPQjqt9XbEn3L27N',
  },
}

export const getGrowthbookConfig = (): TGrowthbookConfig =>
  GROWTHBOOK_CONFIG_MAP[import.meta.env.CURRENT_ENV as CurrentEnvironment] ||
  GROWTHBOOK_CONFIG_MAP[CurrentEnvironment.DEV]
